import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./pump-filter-parameters.style";
import { selectors, useAppSelector } from "store";
import { ParameterInput } from "ui/components/elements/parameter-input";
/**
 * The Tacton parameters that decide which pumps are offered — compressed air
 * connections and the energy saving (ES) function — so they can be changed
 * right where the pump is picked. They stay under "Vacuum pump parameters"
 * too; both places edit the same parameters.
 */
export var PumpFilterParameters = function () {
    var parameters = useAppSelector(selectors.selectPumpFilterParameters);
    if (parameters.length === 0)
        return null;
    return (_jsx(Styled.Root, { children: parameters.map(function (parameter) { return (_jsx(ParameterInput, { parameter: parameter }, parameter.id)); }) }));
};
